import { Link } from "react-router-dom";
import { animes } from "@/mocks/anime";
import AnimeCard from "@/components/feature/AnimeCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function PopularSection() {
  const popular = [...animes].sort((a, b) => b.rating - a.rating).slice(0, 8);
  const ranking = [...animes].sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <section className="w-full py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px]">
          <div>
            <SectionHeading
              kicker="Editor's choice"
              title="热门动漫推荐"
              description="编辑按评分与口碑选出的本周必看，评分来自站内用户长期打分。"
              linkTo="/category?sort=评分最高"
              linkLabel="更多高分作品"
            />
            <div className="grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 xl:grid-cols-4">
              {popular.map((anime) => (
                <AnimeCard key={anime.id} anime={anime} />
              ))}
            </div>
          </div>

          <aside>
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center justify-between">
                <h2 className="text-base font-bold text-foreground-950">人气排行榜</h2>
                <span className="flex items-center gap-1 font-label text-[11px] uppercase tracking-[0.16em] text-primary-600">
                  <i className="ri-fire-line" />
                  Top 6
                </span>
              </div>
              <p className="mt-1.5 text-xs text-foreground-500">按近 7 天站内评分与讨论热度综合排序</p>

              <ul className="mt-4 space-y-1">
                {ranking.map((anime, index) => (
                  <li key={anime.id}>
                    <Link
                      to={`/detail/${anime.id}`}
                      className="group flex items-center gap-3 rounded-md px-1.5 py-2.5 transition-colors hover:bg-background-50"
                    >
                      <span
                        className={[
                          "flex h-6 w-6 shrink-0 items-center justify-center rounded font-label text-xs",
                          index === 0
                            ? "bg-primary-500 text-background-50"
                            : index < 3
                              ? "bg-primary-100 text-primary-700"
                              : "bg-background-200 text-foreground-600",
                        ].join(" ")}
                      >
                        {index + 1}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
                          {anime.title}
                        </span>
                        <span className="mt-0.5 block truncate text-[11px] text-foreground-500">
                          {anime.genres.join(" / ")} · {anime.views} 播放
                        </span>
                      </span>
                      <span className="flex shrink-0 items-center gap-0.5 font-label text-xs text-primary-600">
                        <i className="ri-star-fill text-[10px]" />
                        {anime.rating.toFixed(1)}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>

              <Link
                to="/category?sort=热度最高"
                className="mt-4 flex w-full items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                查看完整榜单
                <i className="ri-arrow-right-line text-sm" />
              </Link>
            </div>

            <div className="mt-5 rounded-lg bg-primary-500 p-5 text-background-50">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20">
                <i className="ri-heart-3-line text-lg" />
              </span>
              <h3 className="mt-3 text-base font-bold">收藏夹同步中</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-primary-50/90">
                在任意动漫页面点一下爱心，作品就会进入「我的收藏」，刷新浏览器也不会丢。
              </p>
              <Link
                to="/category?fav=1"
                className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-3.5 py-2 text-xs font-medium text-primary-700 transition-colors hover:bg-background-100"
              >
                打开我的收藏
                <i className="ri-arrow-right-line text-xs" />
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}